import { useTranslation } from "react-i18next";

function formatTime(ts) {
  try {
    const d = new Date(ts);
    return d.toLocaleTimeString([], { hour: "2-digit", minute: "2-digit", second: "2-digit" });
  } catch {
    return "--:--:--";
  }
}

export function WalletSyncFooter({ lastUpdated, keyPath = "auditor.syncLine" }) {
  const { t } = useTranslation();
  return (
    <div
      className="flex items-center justify-center gap-2 pt-3 text-[11px] text-white/35"
      data-testid="wallet-sync-line"
    >
      <span
        className="inline-flex h-1.5 w-1.5 rounded-full bg-[#22D3EE]"
        style={{ boxShadow: "0 0 6px rgba(34,211,238,0.75)" }}
        aria-hidden
      />
      <span>{t(keyPath, { time: formatTime(lastUpdated) })}</span>
    </div>
  );
}

export default WalletSyncFooter;
